export function blockInteraction(state) {
  state.canInteract = false;
}

export function allowInteraction(state) {
  state.canInteract = true;
}

export function updateBackgroundImage(state, payload) {
  state.backgroundImage = payload;
}

export function setAsQR(state) {
  state.isQR = true;
}

export function setAsNotQR(state) {
  state.isQR = false;
}

export function setDefaultDeliveryMethod(state, { deliveryMethod }) {
  state.defaultDeliveryMethod = deliveryMethod;
}

export function updateVersion(state, { version }) {
  state.version = version;
}

export function setClosed(state) {
  state.closed = true;
}

export function setDistancingOrder(state, payload) {
  state.distancingOrder = payload;
}

export function setLanguage(state, { language }) {
  state.language = language;
}
